import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function CursorGlow() {
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const [isHovering, setIsHovering] = useState(false);
  useEffect(() => {
    const updateMousePosition = (e: MouseEvent) => {
      setMousePosition({
        x: e.clientX,
        y: e.clientY
      });
    };
    const updateHoverState = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      setIsHovering(target.tagName.toLowerCase() === 'button' || target.tagName.toLowerCase() === 'a' || target.closest('button') !== null || target.closest('a') !== null);
    };
    window.addEventListener('mousemove', updateMousePosition);
    window.addEventListener('mouseover', updateHoverState);
    return () => {
      window.removeEventListener('mousemove', updateMousePosition);
      window.removeEventListener('mouseover', updateHoverState);
    };
  }, []);
  return <motion.div className="fixed top-0 left-0 w-8 h-8 rounded-full pointer-events-none z-[9999] mix-blend-screen" animate={{
    x: mousePosition.x - 16,
    y: mousePosition.y - 16,
    scale: isHovering ? 2.5 : 1,
    backgroundColor: isHovering ? 'rgba(34, 211, 238, 0.4)' : 'rgba(124, 92, 252, 0.5)'
  }} transition={{
    type: 'spring',
    stiffness: 500,
    damping: 28,
    mass: 0.5
  }} data-id="element-60">
      <div className="w-full h-full rounded-full blur-md" data-id="element-61" />
    </motion.div>;
}